import { UPDATE_PASSWORD, UPDATE_PASSWORD_SUCCESSFUL, UPDATE_PASSWORD_FAILED} from "./actionTypes"
  
  export const updatePassword = (updatePasswordObject) => {
    return {
      type: UPDATE_PASSWORD,
      payload: { updatePasswordObject }
    }
  }
  
  export const updatePasswordSuccessful = (message) => {
    return {
      type: UPDATE_PASSWORD_SUCCESSFUL,
      payload:message
    }
  }
  
  export const updatePasswordError = (message) => {
    return {
      type: UPDATE_PASSWORD_FAILED,
      payload: {message}
    }
  }